import { ButtonStyle, ControlType, FetchStatus, IEntity, PageMode, Property, PropertyType } from "../../../base/types";
import { FC, useEffect, useState } from "react";
import { IControlAttributes, IPageLink } from "../../../base/models";
import { useNavigate } from "react-router-dom";
import { Registry } from "../../../base/register";
import { useAuth } from "../../../../modules/auth";
import { useGetProperties } from "../../../base/hooks";
import { useDataContext, usePageContext } from "../../page/context";
import { useFormikContext } from "formik";
import { IServiceRequest, ServiceRequestPaymentStage } from "./models";
import clsx from "clsx";
import { FlywireButton, NTTButton, PayTmButton, PayUButton, RazorPayButton } from "../pg-integration";
import { useLazyGetServiceRequestQuery } from "./services";
import { useCreateMutation } from "../../../services/data/tableDataApi";
import { useUploadDocument } from "../../../services/data/sharepoint";
import { useCreateEntityChecklistItemMutation } from "../document-checklist/services/entityChecklistItemsApi";
import { Spinner } from "../../../widgets";
import { KTSVG } from "../../../../helpers";
import { IFieldValue } from "../../../services/models";
import { useLazyGetServiceReqApprovalsQuery } from "./services/serviceReqApprovalsApi";
import { PageLinkHelper } from "../../../base/helpers";
import { useLazyGetContactDetailsQuery } from "../../../services/data/table/contactsApi";

export const ServiceReqAppPayComponent: FC<IControlAttributes> = ({
    control, className, children, props, designerMode, ...rest
}) => {
    const { properties } = useGetProperties({ bindings: control.bindings });
    // const hidden: boolean | undefined = properties[Property.Hidden]
    // const tooltip: string | undefined = properties[Property.Tooltip];
    // const isEditable: boolean | undefined = properties[Property.ModifyAllowed];
    const navigateTo: IPageLink | undefined = properties[Property.PageLink];
    const relativePath: string | undefined = properties[Property.RelativePath];
    const entity: string | undefined = properties[Property.Entity];
    const amount: number | undefined = properties[Property.Amount];
    const serviceRequestId2: string | undefined = properties[Property.ServiceRequestId];
    // const hideHeader: boolean | undefined = properties[Property.HideHeader];
    const [serviceRequest, setServiceRequest] = useState<IServiceRequest>();
    // const navigate = useNavigate()
    // const { siteId, user } = useAuth()
    const [paymentMode, setPaymentMode] = useState<string>('online');
    const [getServicerReq] = useLazyGetServiceRequestQuery()
    const [getApprovalCard, { data: apprvalCard }] = useLazyGetServiceReqApprovalsQuery()

    useEffect(() => {
        if (!serviceRequestId2) return;

        const fetchServiceRequest = () => {
            getServicerReq(serviceRequestId2)
                .unwrap()
                .then((data) => {
                    setServiceRequest(data);
                    if (data.paymentStage === ServiceRequestPaymentStage.Completed ||
                        data.paymentStage === ServiceRequestPaymentStage.Failed) {
                        clearInterval(pollInterval);
                    }
                })
                .catch(err => {
                    console.error("Failed to fetch ServiceRequest", err);
                });
        };

        fetchServiceRequest();
        const pollInterval = setInterval(fetchServiceRequest, 3000); 

        return () => clearInterval(pollInterval);
    }, [serviceRequestId2]);

    useEffect(() => {
        if (serviceRequest) {
            // Assuming 365970001 indicates offline payment type
            if (serviceRequest.paymentType === 365970001) {
                setPaymentMode('offline');
            } else {
                setPaymentMode('online');
            }
        }
    }, [serviceRequest]);

    useEffect(() => {
        if (!serviceRequestId2) return;

        getApprovalCard(serviceRequestId2)
            .unwrap()
            .then();

    }, [serviceRequestId2]);

    return (
        <>
            {apprvalCard?.some(item => item.primaryApproval === true) ? //apprvalCard?.some(item => item.primaryApproval === true)
                <>
                    <div className="mt-5">
                        <div className="d-flex align-items-center card-header ">
                            <h3>Select Payment Mode</h3>
                        </div>
                        <div className="card-body">
                            {(!serviceRequest?.paymentType || serviceRequest.paymentType !== 365970001) && <div className="form-check">
                                <input
                                    type="radio"
                                    id="online"
                                    name="paymentMode"
                                    value="online"
                                    className="form-check-input"
                                    checked={paymentMode === 'online'}
                                    onChange={() => setPaymentMode('online')}
                                />
                                <label htmlFor="online" className="form-check-label">
                                    Online
                                </label>
                            </div>}
                            {serviceRequest?.paymentStage !== ServiceRequestPaymentStage.Completed && (
                                <div className="form-check mt-2">
                                    <input
                                        type="radio"
                                        id="offline"
                                        name="paymentMode"
                                        value="offline"
                                        className="form-check-input"
                                        checked={paymentMode === 'offline'}
                                        onChange={() => setPaymentMode('offline')}
                                    />
                                    <label htmlFor="offline" className="form-check-label">
                                        Offline
                                    </label>
                                </div>
                            )}

                            <div>{paymentMode === 'online' ?
                                (!serviceRequest?.paymentType || serviceRequest.paymentType !== 365970001) ?
                                    <OnlinePayment paymentMode={paymentMode} amount={amount} serviceRequest={serviceRequest} entity={entity} /> : <></> :
                                <OfflinePayment paymentMode={paymentMode} relativePath={relativePath} amount={amount} serviceRequest={serviceRequest} entity={entity} navigateTo={navigateTo}
                                    getServicerReq={getServicerReq}
                                    setServiceRequest={setServiceRequest}
                                />
                            }</div>
                        </div>
                    </div>
                </>
                : <div className="alert alert-primary">Your request is under review. The payment option will be available soon.</div>
            }
        </>
    )
}


const OnlinePayment = ({
    amount,
    paymentMode,
    entity,
    serviceRequest
}: {
    amount?: number,
    serviceRequest?: IServiceRequest,
    entity?: string
    paymentMode: string, // Added paymentMode prop
}) => {
    const { page } = usePageContext()
    const { user } = useAuth()

    const [getContactDetails, { data: contactDetails, isLoading }] = useLazyGetContactDetailsQuery()

    useEffect(() => {
        if (!user) return;
        getContactDetails({ contactId: user.contactId || '' })

        // eslint-disable-next-line
    }, [getContactDetails])

    const currency = "INR";

    if (!user || !serviceRequest || !page || !amount || !contactDetails) {
        return <></>
    }

    const orderNo = serviceRequest.requestNumber;
    const successPage: IPageLink = { pageId: page.id, systemId: serviceRequest.id, pageMode: PageMode.View }
    const failedPage: IPageLink = { pageId: page.id, systemId: serviceRequest.id, pageMode: PageMode.View }

    if (serviceRequest.paymentStage && serviceRequest.paymentStage !== ServiceRequestPaymentStage.Failed) {
        return <PaymentStatus
            serviceRequest={serviceRequest}
            amount={amount} />
    }

    return <>
        <div className="d-flex flex-column gap-1 my-5">
            <div className="flex-fill fs-6 fw-semibold text-gray-600">
                Pay <span className="fs-2 fw-bolder text-gray-800">{formatMoney(amount)}</span> with:
            </div>
            <div className="flex-fill d-flex flex-wrap align-items-stretch gap-2">
                <RazorPayButton
                    className="border border-primary min-w-150px min-h-50px"
                    style={ButtonStyle.OutlinePrimary}
                    enrolmentNo={contactDetails?.rollNumber || user.userName}
                    orderNo={orderNo}
                    entity={entity}
                    entityId={serviceRequest.id}
                    firstName={user.firstName || user.userName}
                    lastName={user.lastName}
                    email={contactDetails?.email}
                    phoneNumber={contactDetails?.mobilePhone}
                    successPage={successPage}
                    failedPage={failedPage}
                    amount={amount}
                    currency={currency} />
            </div>
        </div>
    </>
}

const OfflinePayment = ({
    amount,
    entity,
    getServicerReq,
    setServiceRequest,
    serviceRequest,
    navigateTo,
    paymentMode,
    relativePath
}: {
    amount?: number
    relativePath?: string;
    entity?: string;
    serviceRequest?: IServiceRequest;
    paymentMode: string;
    navigateTo?: IPageLink
    getServicerReq: (id: string) => any;
    setServiceRequest: React.Dispatch<React.SetStateAction<IServiceRequest | undefined>>;
}) => {
    const { user, siteId } = useAuth();
    const { setFieldValue } = useFormikContext<IEntity>() || {};
    const { setData } = useDataContext();
    const navigate = useNavigate();
    const [insertRecord] = useCreateMutation();
    const [formData, setFormData] = useState({
        slcm_amount: "",
        slcm_paidon: "",
        slcm_receiptno: "",
        attachment: null,
    });
    const [isReadonly, setIsReadonly] = useState(false);
    const [statusMessage, setStatusMessage] = useState<string | null>(null);
    const [isConfirmHidden, setIsConfirmHidden] = useState(false);
    const [isRecordCreated, setIsRecordCreated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [documentUrl, setDocumentUrl] = useState<string>("");
    const { uploadDocument } = useUploadDocument()
    const [createRecord] = useCreateEntityChecklistItemMutation()
    const [isUploading, setIsUploading] = useState(false);
    const [errors, setErrors] = useState({
        slcm_amount: "",
        slcm_paidon: "",
        slcm_receiptno: "",
        attachment: "",
    });

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
        setErrors({ ...errors, [name]: "" });
    };

    const handleUpload = (file: File): Promise<string> => {
        if (!relativePath)
            return Promise.reject('Cant upload this document.');

        setIsUploading(true);

        return uploadDocument({ file, folderRelativeUrl: relativePath })
            .then((document) => {
                return createRecord({
                    entityType: entity,
                    entityId: serviceRequest?.id,
                    documentUrl: document.serverAbsoluteUrl || document.serverRelativeUrl,
                })
                    .then(() => Promise.resolve(document.serverAbsoluteUrl))
                    .catch(() => Promise.reject('Cant upload this document.'));
            })
            .catch((error) => {
                console.error(error);
                return Promise.reject(error);
            }).finally(() => setIsUploading(false));
    };

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, files } = e.target;
        if (files) {
            setFormData((prev) => ({
                ...prev,
                [name]: files[0],
            }));

            handleUpload(files[0])
                .then((data) => {
                    setDocumentUrl(data)
                    setErrors({ ...errors, [name]: "" });
                })
                .catch((error) => {
                    setErrors({ ...errors, [name]: "Error uploading document" });
                    console.error("Upload failed:", error);
                });
        } else {
            setFormData((prev) => ({
                ...prev,
                [name]: value,
            }));
        }
    };

    const validateForm = () => {
        const newErrors: any = {};

        // if (!formData.slcm_amount) newErrors.slcm_amount = "Amount is required";
        if (!formData.slcm_paidon) newErrors.slcm_paidon = "Date is required";
        if (!formData.slcm_receiptno) newErrors.slcm_receiptno = "Receipt No is required";
        if (!formData.attachment) newErrors.attachment = "Attachment is required";

        setErrors(newErrors);

        return Object.keys(newErrors).length === 0;
    };

    const createPaymentRecord = (data: any) => {
        setLoading(true)
        saveFormData(data)
            .then(data => {
                setData({ type: "Card", result: data, status: FetchStatus.Success });
                setIsReadonly(true);
                setIsConfirmHidden(true);
                setIsRecordCreated(true);
                if (serviceRequest?.id) {
                    getServicerReq(serviceRequest.id)
                        .unwrap()
                        .then((data: IServiceRequest) => {
                            setServiceRequest(data);
                        })
                        .catch((err: any) => {
                            console.error("Failed to refresh service request:", err);
                        });
                }
            })
            .catch(err => {
                const message = err.data.message || 'An error occurred while processing your request. Please try again later.';
                setStatusMessage(message);
            }).finally(() => setLoading(false));
    };

    const saveFormData = (record: IEntity): Promise<IEntity> => {
        const fields: IFieldValue[] = Object.entries(record)
            .filter(([_, value]) => value !== undefined)
            .map(([field, value]) => ({ field, value, validate: true }));

        return insertRecord({ portalId: siteId || '', userId: user?.contactId, tableId: "slcm_payment", data: fields, triggers: true })
            .unwrap()
            .catch(err => {
                const message = err.data.message || 'An error occurred while processing your request. Please try again later.';
                setStatusMessage(message);
                return Promise.reject(message);
            });
    };

    const handleConfirm = () => {
        if (!validateForm()) return;

        const paymentData = {
            slcm_rollno: user?.contactId,
            slcm_amount: amount,
            slcm_paidon: formData.slcm_paidon,
            slcm_receiptno: formData.slcm_receiptno,
            edtec365_servicerequest: serviceRequest?.id,
            slcm_documentlink: documentUrl,
        };

        createPaymentRecord(paymentData);
    };


    if (!user || !serviceRequest || !amount) {
        return <></>;
    }

    return (
        <div className="d-flex flex-column gap-1 my-5">
            {(!serviceRequest?.paymentType || serviceRequest.paymentType !== 365970001) ? <div className="container mt-3">
                <h5 className="mb-3">Offline Payment Details</h5>
                <div className="row g-3">
                    <div className="col-md-4">
                        <label htmlFor="slcm_amount" className="form-label fw-semibold required">
                            Amount
                        </label>
                        <input
                            type="number"
                            className="form-control"
                            id="slcm_amount"
                            name="slcm_amount"
                            value={amount}
                            onChange={handleChange}
                            disabled={isReadonly}
                            placeholder="Enter Amount"
                            required={true}
                        />
                        {errors.slcm_amount && <div className="text-danger">{errors.slcm_amount}</div>}
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="slcm_paidon" className="form-label fw-semibold required">
                            Date
                        </label>
                        <input
                            type="date"
                            className="form-control"
                            id="slcm_paidon"
                            name="slcm_paidon"
                            value={formData.slcm_paidon}
                            onChange={handleChange}
                            disabled={isReadonly}
                            required={true}
                        />
                        {errors.slcm_paidon && <div className="text-danger">{errors.slcm_paidon}</div>}
                    </div>

                    <div className="col-md-4">
                        <label htmlFor="slcm_receiptno" className="form-label fw-semibold required">
                            Receipt No
                        </label>
                        <input
                            type="text"
                            className="form-control"
                            id="slcm_receiptno"
                            name="slcm_receiptno"
                            value={formData.slcm_receiptno}
                            onChange={handleChange}
                            disabled={isReadonly}
                            placeholder="Enter Receipt No"
                            required={true}
                        />
                        {errors.slcm_receiptno && <div className="text-danger">{errors.slcm_receiptno}</div>}
                    </div>
                </div>

                <div className="mt-3">
                    <label htmlFor="attachment" className="form-label fw-semibold">
                        Attach Document
                    </label>
                    <input
                        type="file"
                        id="attachment"
                        name="attachment"
                        className="form-control"
                        onChange={handleInputChange}
                        disabled={isReadonly}
                    />
                    {errors.attachment && <div className="text-danger">{errors.attachment}</div>}
                    {isUploading && <Spinner className='me-2' show={isUploading} />}
                </div>

                <div className="mt-4">
                    {!isConfirmHidden && (
                        <button type='button'
                            onClick={handleConfirm}
                            disabled={loading}
                            className='btn btn-lg btn-primary me-3'>
                            <span className='indicator-label'>
                                {loading && <Spinner className='me-2' show={loading} />}
                                <span>Confirm</span>

                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr064.svg'
                                    className='svg-icon-3 ms-2 me-0'
                                />
                            </span>
                        </button>
                    )}
                </div>
            </div> :
                <div className="d-flex align-items-center gap-1">
                    <div><span className="badge badge-info">Offline Payment Received.</span></div>
                </div>
            }
        </div>
    );
};

const PaymentStatus = ({ serviceRequest, amount, className }: {
    serviceRequest: IServiceRequest,
    amount: number,
    className?: string,
}) => {
    const getStatus = () => {
        switch (serviceRequest.paymentStage) {
            case ServiceRequestPaymentStage.Completed:
                return "Payment Received.";
            case ServiceRequestPaymentStage.OnGoing:
            case ServiceRequestPaymentStage.Pending:
                return "Waiting for confirmation from the bank.";
        }
    }

    return <>
        <div className={clsx(className, "d-flex align-items-center gap-1")}>
            <span className="fs-2 fw-bolder text-gray-800">{formatMoney(amount)}</span>
            <div><span className="badge badge-info">{getStatus()}</span></div>
        </div>
    </>
}

const formatMoney = (number?: number | string) => {
    if (!number) number = 0;

    if (typeof number !== 'number') {
        number = Number(number)
    }

    const formatter = new Intl.NumberFormat(navigator.language, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    return formatter.format(number);
}

Registry.addControl({
    id: "a1145184-b1ff-4062-bae3-431c1c189323",
    name: "Service Req Approval Payment",
    type: ControlType.ServiceReqApprovalPayment,
    properties: [
        { id: Property.Entity, name: 'Service Request Entity', type: PropertyType.Entity },
        { id: Property.ServiceRequestId, name: 'Service Request Id', type: PropertyType.String },
        { id: Property.Amount, name: 'Amount', type: PropertyType.Number },
        { id: Property.PageLink, name: 'Navigate To', type: PropertyType.PageLink },
        { id: Property.RelativePath, name: 'Relative Path', type: PropertyType.String },
        { id: Property.Tooltip, name: 'Tooltip', type: PropertyType.String },
    ],
    component: ServiceReqAppPayComponent
})


